module.exports = __webpack_public_path__ + "img/logo-big.971213ea.svg";